import { upperCase } from "lodash";

/**
 * check boolean paymentus flag.
 * <p>ported from Java code.
 * 
 * 
 * @param {*} s 
 * @param {boolean} dflt optional. default is false 
 */
export function toBoolean(s:string, dflt?:boolean) {
    if(!s) return !!dflt;

    s = upperCase(s);

    if (s === "Y") {
        return true;
    }

    if (s === "YES") {
        return true;
    }

    if (s === "TRUE") {
        return true;
    }

    if (s === "1") {
        return true;
    }

    return !!dflt;
}